import { Dispatch } from "redux";
import { StoreAction } from "../../utils/actions";
import { IDepartment, IDistrict, ILocation, ILookup, IMunicipality, IProgramme, ISector } from "../../app/modules/core/_models";

/** Set full event list */
export const fetchDepartmentMasterAction =
    (departmentData: IDepartment[] | []) =>
        async (dispatch: Dispatch) => {
            dispatch({
                type: StoreAction.DEPARTMENTS_DATA,
                payload: departmentData,
            });
        };

export const fetchSectorMasterAction =
    (sectorData: ISector[] | []) =>
        async (dispatch: Dispatch) => {
            dispatch({
                type: StoreAction.SECTORS_DATA,
                payload: sectorData,
            });
        };

export const fetchPriorityMasterAction =
    (priorityData: ILookup[] | []) =>
        async (dispatch: Dispatch) => {
            dispatch({
                type: StoreAction.PRIORITIES_DATA,
                payload: priorityData,
            });
        };

export const fetchProjectTypeMasterAction =
    (projectTypeData: ILookup[] | []) =>
        async (dispatch: Dispatch) => {
            dispatch({
                type: StoreAction.PROJECT_TYPES_DATA,
                payload: projectTypeData,
            });
        };

export const fetchActionProjectTypeMasterAction =
    (actionProjectTypeData: ILookup[] | []) =>
        async (dispatch: Dispatch) => {
            dispatch({
                type: StoreAction.ACTION_PROJECT_TYPES_DATA,
                payload: actionProjectTypeData,
            });
        };

export const fetchJurisdictionMasterAction =
    (jurisdictionData: ILookup[] | []) =>
        async (dispatch: Dispatch) => {
            dispatch({
                type: StoreAction.JURISDICTION_DATA,
                payload: jurisdictionData,
            });
        };

export const fetchDistrictMasterAction =
    (districtData: IDistrict[] | []) =>
        async (dispatch: Dispatch) => {
            dispatch({
                type: StoreAction.DISTRICT_DATA,
                payload: districtData,
            });
        };    



export const fetchMunicipalityMasterAction =
    (municipalityData: IMunicipality[] | []) =>
        async (dispatch: Dispatch) => {
            dispatch({
                type: StoreAction.MUNICIPALITY_DATA,
                payload: municipalityData,
            });
        };

export const fetchProgrammeMasterAction =
    (programmeData: IProgramme[] | []) =>
        async (dispatch: Dispatch) => {
            dispatch({
                type: StoreAction.PROGRAMMES_DATA,
                payload: programmeData,
            });
        };

export const fetchIdmsProjectStageMasterAction =
    (idmsProjectStageData: ILookup[] | []) =>
        async (dispatch: Dispatch) => {
            dispatch({
                type: StoreAction.IDMS_PROJECT_STAGE_DATA,
                payload: idmsProjectStageData,
            });
        };

export const fetchLocationMasterAction =
    (locationData: ILocation[] | []) =>
        async (dispatch: Dispatch) => {
            dispatch({
                type: StoreAction.LOCATION_DATA,
                payload: locationData,
            });
        };